import Base from "./_BaseComponent";
import $ from "jquery";

class FormComponent extends Base.Component {
	private loading: boolean = false;

	public onMount(): void {
		this.element.on("submit", this.preventResubmission.bind(this));
	}

	private preventResubmission(e: any) {
		if (this.loading) {
			e.preventDefault();
			return;
		}

		this.loading = true;
		this.element.addClass("loading");
		this.element.find("[data-bind=submit]").html("<p>Submitting your enquiry. Please wait...</p>");
	}

}

export default Base.Init("[data-form-component]", FormComponent);
